exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-polyfill/node_modules/core-js/modules/_wks-ext.js
// module id = 374
// module chunks = 0